import { render, staticRenderFns } from "./popupOfDialog.vue?vue&type=template&id=46bbd256&scoped=true&"
import script from "./popupOfDialog.vue?vue&type=script&lang=js&"
export * from "./popupOfDialog.vue?vue&type=script&lang=js&"
import style0 from "./popupOfDialog.vue?vue&type=style&index=0&id=46bbd256&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bbd256",
  null
  
)

export default component.exports